import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { useIntl, FormattedMessage } from 'react-intl';
import axios from 'axios';

import { devices } from 'styles/devices';
import SidebarTemplate from 'templates/SidebarTemplate/SidebarTemplate';
import Headline from 'ui/Headline';
import Section from 'components/Section';
import Popup from 'components/Popup';

export const renderPricePages = (intl) =>
   axios
      .get('/wp/v2/posts', {
         params: {
            categories: 46,
            tags: 115,
            per_page: 100
         }
      })
      .then(({ data }) => {
         return data
            .sort((a, b) => {
               const aa = parseInt(a.acf?.kolejnosc, 10);
               const bb = parseInt(b.acf?.kolejnosc, 10);
               if (isNaN(aa)) {
                  return 1;
               }
               if (isNaN(bb)) {
                  return -1;
               }
               return aa - bb;
            })
            .map((p) => {
               if (p.title.rendered.includes('Panel 2D/2DS')) {
                  return (
                     <div key={p.id}>
                        <div className="page">
                           <div>
                              <h2 className="h3">{parse(p.title.rendered)}</h2>
                           </div>
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.GateSelfsupporting' })}
                              id={`bramy_samonosne--${p.id}`}
                           >
                              {parse(p?.acf.bramy_samonosne || '', { trim: true })}
                           </Section>
                        </div>
                        <div className="page">
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.GateTilting' })}
                              id={`bramy_uchylne--${p.id}`}
                           >
                              {parse(p?.acf.bramy_uchylne || '', { trim: true })}
                           </Section>
                        </div>
                        <div className="page">
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.Gateway' })}
                              id={`furtki--${p.id}`}
                           >
                              {parse(p?.acf.furtki || '', { trim: true })}
                           </Section>
                        </div>
                        <div className="page">
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.Span' })}
                              id={`przesla_m--${p.id}`}
                           >
                              {parse(p?.acf.przesla_m || '', { trim: true })}
                           </Section>
                        </div>
                     </div>
                  );
               }
               if (p.title.rendered.includes('DIVERSO')) {
                  return (
                     <div key={p.id}>
                        <div className="page">
                           <div>
                              <h2 className="h3">{parse(p.title.rendered)}</h2>
                           </div>
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.GateSelfsupporting' })}
                              id={`bramy_samonosne--${p.id}`}
                           >
                              {parse(p?.acf.bramy_samonosne || '', { trim: true })}
                           </Section>
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.GateTilting' })}
                              id={`bramy_uchylne--${p.id}`}
                           >
                              {parse(p?.acf.bramy_uchylne || '', { trim: true })}
                           </Section>
                        </div>
                        <div className="page">
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.Gateway' })}
                              id={`furtki--${p.id}`}
                           >
                              {parse(p?.acf.furtki || '', { trim: true })}
                           </Section>
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.Span' })}
                              id={`przesla_m--${p.id}`}
                           >
                              {parse(p?.acf.przesla_m || '', { trim: true })}
                           </Section>
                        </div>
                     </div>
                  );
               }
               if (p.title.rendered.includes('Panel 3D')) {
                  return (
                     <div key={p.id}>
                        <div className="page">
                           <div>
                              <h2 className="h3">{parse(p.title.rendered)}</h2>
                           </div>
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.GateSelfsupporting' })}
                              id={`bramy_samonosne--${p.id}`}
                           >
                              {parse(p?.acf.bramy_samonosne || '', { trim: true })}
                           </Section>
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.GateTilting' })}
                              id={`bramy_uchylne--${p.id}`}
                           >
                              {parse(p?.acf.bramy_uchylne || '', { trim: true })}
                           </Section>
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.Gateway' })}
                              id={`furtki--${p.id}`}
                           >
                              {parse(p?.acf.furtki || '', { trim: true })}
                           </Section>
                        </div>
                        <div className="page">
                           <Section
                              headline={intl.formatMessage({ id: 'PriceView.Span' })}
                              id={`przesla_m--${p.id}`}
                           >
                              {parse(p?.acf.przesla_m || '', { trim: true })}
                           </Section>
                        </div>
                     </div>
                  );
               }
               if (p.title.rendered.includes('Podmurówki')) {
                  return (
                     <div key={p.id}>
                        <div className="page">
                           <div>
                              <h2 className="h3">{parse(p.title.rendered)}</h2>
                           </div>
                           {p?.acf.plyta_prefabrykowana_gladka && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.PrefabricatedPlateSmooth'
                                 })}
                                 id={`plyta_prefabrykowana_gladka--${p.id}`}
                              >
                                 {parse(p?.acf.plyta_prefabrykowana_gladka || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.plyta_prefabrykowana_cegla && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.PrefabricatedPlateBrick'
                                 })}
                                 id={`plyta_prefabrykowana_cegla--${p.id}`}
                              >
                                 {parse(p?.acf.plyta_prefabrykowana_cegla || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.deska_betonowa_pelna && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.ConcreteBoardFull'
                                 })}
                                 id={`deska_betonowa_pelna--${p.id}`}
                              >
                                 {parse(p?.acf.deska_betonowa_pelna || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.deska_betonowa_bps && (
                              <Section
                                 headline={intl.formatMessage({ id: 'PriceView.ConcreteBoardBPS' })}
                                 id={`deska_betonowa_bps--${p.id}`}
                              >
                                 {parse(p?.acf.deska_betonowa_bps || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.deska_betonowa_plukana_pelna && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.FullWashedConcreteBoard'
                                 })}
                                 id={`deska_betonowa_plukana_pelna--${p.id}`}
                              >
                                 {parse(p?.acf.deska_betonowa_plukana_pelna || '', { trim: true })}
                              </Section>
                           )}
                        </div>
                        <div className="page">
                           {p?.acf.lacznik_betonowy && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.ConcreteConnector'
                                 })}
                                 id={`lacznik_betonowy--${p.id}`}
                              >
                                 {parse(p?.acf.lacznik_betonowy || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.ceownik_montazowy && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.MountingChannel'
                                 })}
                                 id={`ceownik_montazowy--${p.id}`}
                              >
                                 {parse(p?.acf.ceownik_montazowy || '', { trim: true })}
                              </Section>
                           )}
                        </div>
                     </div>
                  );
               }
               if (p.title.rendered.includes('Akcesoria')) {
                  return (
                     <div key={p.id}>
                        <div className="page">
                           <div>
                              <h2 className="h3">{parse(p.title.rendered)}</h2>
                           </div>
                           {p?.acf.akcesoria_do_furtek && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.GatewayAccesories'
                                 })}
                                 id={`akcesoria_do_furtek--${p.id}`}
                              >
                                 {parse(p?.acf.akcesoria_do_furtek || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.akcesoria_do_bram_uchylnych && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.GateTiltingAccesories'
                                 })}
                                 id={`akcesoria_do_bram_uchylnych--${p.id}`}
                              >
                                 {parse(p?.acf.akcesoria_do_bram_uchylnych || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.akcesoria_do_bram_samonosnych && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.GateSelfsupportingAccesories'
                                 })}
                                 id={`akcesoria_do_bram_samonosnych--${p.id}`}
                              >
                                 {parse(p?.acf.akcesoria_do_bram_samonosnych || '', { trim: true })}
                              </Section>
                           )}
                        </div>
                        <div className="page">
                           {p?.acf.obejmy_60 && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.Clamps60'
                                 })}
                                 id={`obejmy_60--${p.id}`}
                              >
                                 {parse(p?.acf.obejmy_60 || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.obejmy_60x40 && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.Clamps60x40'
                                 })}
                                 id={`obejmy_60x40--${p.id}`}
                              >
                                 {parse(p?.acf.obejmy_60x40 || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.lacznik_betonowy && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.SpansPriceFor1m2'
                                 })}
                                 id={`cena_przesel_za_1_m2_1/3--${p.id}`}
                              >
                                 {parse(p?.acf.lacznik_betonowy || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.ceownik_montazowy && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.SpansPriceFor1m2'
                                 })}
                                 id={`cena_przesel_za_1_m2_2/3--${p.id}`}
                              >
                                 {parse(p?.acf.ceownik_montazowy || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.deska_betonowa_bps && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.SpansPriceFor1m2'
                                 })}
                                 id={`cena_przesel_za_1_m2_3/3--${p.id}`}
                              >
                                 {parse(p?.acf.deska_betonowa_bps || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.plyta_xps && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.PlateXPS'
                                 })}
                                 id={`plyta_xps--${p.id}`}
                              >
                                 {parse(p?.acf.plyta_xps || '', { trim: true })}
                              </Section>
                           )}
                        </div>
                        <div className="page">
                           {p?.acf.automatyka && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.Automation'
                                 })}
                                 id={`automatyka--${p.id}`}
                              >
                                 {parse(p?.acf.automatyka || '', { trim: true })}
                              </Section>
                           )}
                           {p?.acf.dodatkowe_akcesoria && (
                              <Section
                                 headline={intl.formatMessage({
                                    id: 'PriceView.AdditionalAccessories'
                                 })}
                                 id={`dodatkowe_akcesoria--${p.id}`}
                              >
                                 {parse(p?.acf.dodatkowe_akcesoria || '', { trim: true })}
                              </Section>
                           )}
                        </div>
                     </div>
                  );
               }

               return (
                  <div className="page" key={p.id}>
                     <div>
                        <h2 className="h3">{parse(p.title.rendered)}</h2>
                     </div>
                     {p?.acf.slupek_eq && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.PoleEQ'
                           })}
                           id={`slupek_eq--${p.id}`}
                        >
                           {parse(p?.acf.slupek_eq || '', { trim: true })}
                        </Section>
                     )}
                     {p?.acf.dodatkowe_akcesoria && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.AdditionalAccessories'
                           })}
                           id={`dodatkowe_akcesoria--${p.id}`}
                        >
                           {parse(p?.acf.dodatkowe_akcesoria || '', { trim: true })}
                        </Section>
                     )}

                     {p?.acf.slupki && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.Poles'
                           })}
                           id={`slupki--${p.id}`}
                        >
                           {parse(p?.acf.slupki || '', { trim: true })}
                        </Section>
                     )}
                     {p?.acf.marki && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.Holders'
                           })}
                           id={`marki--${p.id}`}
                        >
                           {parse(p?.acf.marki || '', { trim: true })}
                        </Section>
                     )}

                     {p?.acf.bramy_samonosne && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.GateSelfsupporting'
                           })}
                           id={`bramy_samonosne--${p.id}`}
                        >
                           {parse(p?.acf.bramy_samonosne || '', { trim: true })}
                        </Section>
                     )}
                     {p?.acf.bramy_uchylne && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.GateTilting'
                           })}
                           id={`bramy_uchylne--${p.id}`}
                        >
                           {parse(p?.acf.bramy_uchylne || '', { trim: true })}
                        </Section>
                     )}
                     {p?.acf.furtki && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.Gateway'
                           })}
                           id={`furtki--${p.id}`}
                        >
                           {parse(p?.acf.furtki || '', { trim: true })}
                        </Section>
                     )}
                     {p?.acf.przesla_m && (
                        <Section
                           headline={intl.formatMessage({
                              id: 'PriceView.Span'
                           })}
                           id={`przesla_m--${p.id}`}
                        >
                           {parse(p?.acf.przesla_m || '', { trim: true })}
                        </Section>
                     )}
                  </div>
               );
            });
      });

const PriceView = () => {
   const [rendered, setRendered] = useState(null);
   const intl = useIntl();

   useEffect(() => {
      renderPricePages(intl).then((res) => setRendered(res));
   }, [intl]);

   return (
      <SidebarTemplate navigation="priceList">
         <Top>
            <Headline size="XXL">
               <FormattedMessage id="CatalogView.PriceList" />
            </Headline>
         </Top>
         {rendered}
         <Popup />
      </SidebarTemplate>
   );
};
const Top = styled.div`
   ${devices.mobile} {
      display: flex;
      align-items: center;
   }
`;

export default PriceView;
